import { util } from '.'
import { constants } from '../constants'
import { formatString, strings } from '../context/LanguageContext/strings'

export const productsUtil = {
    productDetailsURL: id => {
        return constants.routePaths.manage_update_product_details.path.replace(
            ':productDraftId',
            id
        )
    },
    formRequiredError: (error, message) => (error ? (message ? message : 'required') : ''),
    nutritionStateConfig: (value, remains) => {
        const baseConfig = {
            name: value,
            key: value,
            quantity: '',
            uom: 'g',
            percentage: '',
            groupBy: 'nutrients',
            isUpdating: true,
            isRequired: true,
            validate: function () {
                return !!this.quantity
            },
        }
        return { ...baseConfig, ...remains }
    },
    parseProductSetUp: status => {
        switch (status) {
            case 'not_started':
                return {
                    color: 'initial',
                    icon: util.RemoveCircleOutlineIcon,
                    label: strings.NOT_STARTED,
                }

            case 'incomplete':
                return {
                    color: 'warning',
                    icon: util.ReportProblemOutlinedIcon,
                    label: strings.INCOMPLETE,
                }

            case 'complete':
                return {
                    color: 'success',
                    icon: util.CheckCircleRoundedIcon,
                    label: strings.COMPLETE,
                }

            case 'saved':
                return {
                    color: 'success',
                    icon: util.CheckCircleRoundedIcon,
                    label: strings.SAVED,
                }

            default:
                return {}
        }
    },
    setNutritionInfo: ({ name, quantity, uom, percentage }, options, thirdPartyProvider) => {
        const nutrition = {
            key: name,
            name,
            quantity,
            uom,
            percentage,
            groupBy: 'nutrients',
            isSubNutrient: true,
            isUpdating: false,
            ...(!thirdPartyProvider
                ? {
                      isRequired: true,
                      inDB: true,
                      validate: function () {
                          if (!this.isSubNutrient) {
                              return true
                          }
                          return !!this.quantity && (this.isUpdating || this.inDB)
                      },
                  }
                : null),
        }
        return { ...nutrition, ...options }
    },
    setOtherNutrients: (nutrient, thirdPartyProvider) => ({
        ...nutrient,
        key: nutrient.name,
        isOtherNutrient: true,
        groupBy: 'nutrients',
        ...(!thirdPartyProvider
            ? {
                  isRequired: true,
                  validate: function () {
                      return !!this.quantity
                  },
              }
            : null),
    }),
    productSectionStateUpdates: (baseState, currState) => {
        Object.keys(baseState).forEach(key => {
            if (!currState.hasOwnProperty(key)) {
                currState[key] = baseState[key]
            }
        })
        return currState
    },
    setPublishContext: status => {
        return status === 'none'
            ? {
                  title: formatString('PUBLISH_TO_ENV', { ENV: strings.QA }),
                  description: strings.PUBLISH_TO_QA_DESCRIPTION,
              }
            : {
                  title: formatString('PUBLISH_TO_ENV', { ENV: strings.PRODUCTION }),
                  description: strings.PUBLISH_TO_PROD_DESCRIPTION,
              }
    },
    setPublishText: status => {
        const env =
            status === 'none' ? strings.QA : status === 'qa' ? strings.PRODUCTION : undefined
        if (!env) {
            return null
        }
        return formatString('PUBLISH_TO_ENV', { ENV: env })
    },
    isProductInQA: visibility => visibility === 'qa',
    isProductPublished: visibility => visibility === 'qa' || visibility === 'prod',
    isProductProdPublished: visibility => (visibility && visibility === 'prod') || false,
    publishAlertStr: visibility => {
        return visibility === 'prod'
            ? 'This product has been successfully published to Production. It will appear in production according to the online status setting (Active, Inactive, or scheduled).'
            : visibility === 'qa'
              ? 'This product has been successfully published to QA.'
              : ''
    },
    getFormattedPriceValue: price => price / 100,
    extractProductSections: ({
        product_info,
        id_slin,
        categories_filters,
        status_and_rules,
        services_marketplaces,
        pricing,
    }) => [
        product_info,
        id_slin,
        categories_filters,
        status_and_rules,
        services_marketplaces,
        pricing,
    ],
    updateModifiedAreaState: (sectionState, modified_area) => {
        Object.keys(sectionState).forEach(key => {
            if (util.isObject(sectionState[key])) {
                const isModified =
                    !!modified_area &&
                    (!!modified_area[key] || !!modified_area[key.replace('_', ' ')])

                sectionState[key] = {
                    ...sectionState[key],
                    isModified,
                }
            }
        })
        return sectionState
    },
    mapProductStatus: (status, statusRules) => {
        if (
            status &&
            (status === constants.productStatuses.DRAFT ||
                status === constants.productStatuses.IMPORTED)
        ) {
            return '-'
        }
        const { online_status } = statusRules || {}
        if (status === constants.productStatuses.PUBLISHED) {
            return online_status
        }
    },
    displayModified: state => {
        return state.hasOwnProperty('isModified') && state.isModified
    },
    parseModifiedAreas: areas => {
        return areas.map(area => {
            return area.split('.').pop().replace(/_/g, ' ')
        })
    },
    manageProductDetailsURL: id => {
        return constants.routePaths.products_product_details.path.replace(':productId', id)
    },
}
